import React, { useEffect, useState } from "react";
import { Card, CardContent, Typography, Box } from "@mui/material";

const CameraTile = React.memo(
  function CameraTile({ name, producerId, getStream, sx }) {
    const [stream, setStream] = useState(null);

    useEffect(() => {
      let cancelled = false;
      getStream(producerId)
        .then((s) => !cancelled && setStream(s))
        .catch(console.error);
      return () => {
        cancelled = true;
      };
    }, [producerId, getStream]);

    const lower = name.toLowerCase();
    const isSideLabel = lower === "right" || lower === "left";
    const side = lower === "right" ? "right" : "left";
    const letters = name.toUpperCase().split("");

    return (
      <Card
        sx={[
          {
            position: "relative",
            display: "flex",
            flexDirection: "column",
            flex: "1 1 auto",
            minHeight: 0,
            overflow: "hidden",
          },
          sx,
        ]}
      >
        {/* side title */}
        {isSideLabel && (
          <Box
            sx={{
              position: "absolute",
              top: 0,
              bottom: 0,
              [side]: 0,
              width: 32,
              bgcolor: "red",
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-evenly",
              alignItems: "center",
              zIndex: 2,
            }}
          >
            {letters.map((c) => (
              <Typography
                key={c}
                variant="caption"
                sx={{ lineHeight: 1, color: "white", fontWeight: "bold", fontSize: 20 }}
              >
                {c}
              </Typography>
            ))}
          </Box>
        )}

        {/* content */}
        <CardContent
          sx={{
            flex: 1,
            p: 0,                                 // wipe default padding
            pl: isSideLabel && side === "left" ? 5 : 1,
            pr: isSideLabel && side === "right" ? 5 : 1,

            // ⬇ kill the implicit 24 px on the last child
            "&:last-child": { paddingBottom: 0 },

            display: "flex",
            flexDirection: "column",
            minHeight: 0,
            overflow: "hidden",
          }}
        >
          {!isSideLabel && (
            <Typography
              variant="subtitle1"
              sx={{ fontWeight: "bold", textAlign: "left" }}
              fontSize={24}
              gutterBottom
            >
              {name}
            </Typography>
          )}

          {/* video wrapper – handles vertical AND horizontal centering */}
          <Box
            sx={{
              flex: 1,
              minHeight: 0,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              overflow: "hidden",
            }}
          >
            <video
              autoPlay
              playsInline
              muted
              ref={(v) => v && stream && (v.srcObject = stream)}
              style={{
                width: "100%",
                height: "100%",
                objectFit: "contain",
                background: "#202020",
                borderRadius: 4,
              }}
            />
          </Box>
        </CardContent>
      </Card>
    );
  },
  (prev, next) => prev.producerId === next.producerId
);

export default CameraTile;
